import bildOnline from '@/assets/icons/termin_online.svg';
import bildVorOrt from '@/assets/icons/termin_vor_ort.svg';


export const appointmentOptions = [
    { name: 'Ich möchte einen Vor-Ort-Termin', available: true, value: 'onsite', api: null, image: bildVorOrt },
    { name: 'Weiter mit Online-Beratung', available: true, value: 'online', api: null,  image: bildOnline },
];

